export default "__VITE_ASSET__CwbFKKNg__"